export default __webpack_public_path__ + "static/media/logo.2906e88e.svg";